import "@/styles/globals.css";
import "@/styles/index.scss";
import type { AppProps } from "next/app";

import { ApolloProvider } from "@apollo/client";
import client from "../src/apollo/client";
import { ThemeProvider } from "@material-tailwind/react";
import { ShopifyProvider, CartProvider } from "@shopify/hydrogen-react";

import { createContext, useState } from "react";
import BaseWrapper from "@/src/components/Layout/BaseWrapper";
import { Roboto } from "next/font/google";
import { GTAG_ID } from "@/src/constants";
import { GoogleAnalytics } from "@next/third-parties/google";

const roboto = Roboto({
  subsets: ["latin"],
  weight: ["400", "700"],
  display: "swap",
});

export interface AuthObj {
  authToken: string;
  paywallLevel: string;
  userData: string;
  isLoggedIn: boolean;
  userId: string;
  userEmail: string;
  isPaywall: boolean;
  leakyPaywall: boolean;
  subs?: string[];
}

const defaultAuthObj: AuthObj = {
  authToken: "",
  paywallLevel: "",
  userData: "",
  isLoggedIn: false,
  userId: "",
  userEmail: "",
  isPaywall: false,
  leakyPaywall: false,
  subs: [],
};

export interface AuthContextType {
  authContext?: AuthObj;
  setAuthContext?: (auth: any) => void;
}

export const AuthContext = createContext<AuthContextType>({});

const AuthContextProvider = ({ children }: any) => {
  const [authContext, setAuthContext] = useState(defaultAuthObj);

  return (
    <AuthContext.Provider value={{ authContext, setAuthContext }}>
      {children}
    </AuthContext.Provider>
  );
};

export default function App({ Component, pageProps, router }: AppProps) {
  return (
    <main className={roboto.className} style={{height: "100vh"}}>
      <ApolloProvider client={client}>
        <ThemeProvider>
          <ShopifyProvider
            // storeDomain={`https://${process.env.NEXT_SHOPIFY_STORE_DOMAIN}.myshopify.com`}
            // TODO shopifyenv
            storeDomain={`https://heganx-1j.myshopify.com`}
            // storefrontToken={process.env.NEXT_SHOPIFY_PUBLIC_ACCESS_TOKEN!}
            storefrontToken="516df6029e81195e555c1e067839d180"
            storefrontApiVersion="2025-04"
            countryIsoCode="AU"
            languageIsoCode="EN"
          >
            <CartProvider>
              <AuthContextProvider>
                <BaseWrapper
                  Component={Component}
                  router={router}
                  {...pageProps}
                />
                <GoogleAnalytics gaId={GTAG_ID} />
              </AuthContextProvider>
            </CartProvider>
          </ShopifyProvider>
        </ThemeProvider>
      </ApolloProvider>
    </main>
  );
}
